import { stitch } from 'keo';
import moment from 'moment';
import r from 'render-dom';
import { SubmissionError } from 'redux-form';
import { parseQueryString } from 'utils/helpers';

import { login } from 'redux/auth/actions';

import Login from './Login';

const render = ({
    props: {
        history,
        location,
        me,
        postLogin,
    }
}) => {
    const isNewAccount = moment().diff(me.get('createdAt'), 'days') < 8;
    const onSubmit = (loginFields) => postLogin(loginFields).then(
        () => {
            const { ref } = parseQueryString(location.search);
            if (ref) {
                history.push(ref);
            } else if (isNewAccount) {
                history.push('/welcome');
            } else {
                history.push('/');
            }
        },
        (err) => {
            throw new SubmissionError(err);
        }
    );

    return r(Login, { location, onSubmit });
};

export default stitch(
    { render },
    ({ me }) => ({ me: me.get('data') }),
    { postLogin: login }
);



// WEBPACK FOOTER //
// ./src/components/public/Login/index.js